module.exports = __webpack_public_path__ + "static/media/interface_example.0d9132ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/interface_example.png
// module id = 759
// module chunks = 0